module.exports = {
    解析打印模版: function (模版 = '', 数据 = {}) {
        //解析jo数据
        模版 = 模版.replace(/\r/g, '').replace(/\n/g, '');   //先去掉换行,  换行会影响正则
        if (Array.isArray(数据)) throw '解析模版的数据只能为JObject类型';

        return this.解析jo数据(模版, 数据);
    },
    解析jo数据: function (模版, jo数据) {
        for (const key in jo数据) {
            const value = jo数据[key];
            if (Array.isArray(value)) {  //typeof value=='object' && 
                模版 = this.解析ja数据(模版, value, key);
            }
        }
        //先解析jo里面的内容,解析完了,才能解析ja  避免jo里面的ja的可以跟外层ja的key相同
        for (const key in jo数据) {
            let value = jo数据[key];
            if (Array.isArray(value)) continue;
            if (typeof value == 'object') {
                for (const key2 in value) {
                    const value2 = value[key2];
                    模版 = 模版.replace(new RegExp('{{' + key + '.' + key2 + '}}', 'g'), value2);
                }
                continue;
            }
            模版 = 模版.replace(new RegExp('{{' + key + '}}', 'g'), value);
            // 模版 = 模版.replace(new RegExp('{{' + key + '.toFixed\\(2\\)}}', 'g'), value.toFixed(2));
            // 模版 = 模版.replace(new RegExp('{{' + key + '.toFixed\\(4\\)}}', 'g'), value.toFixed(4));
        }
        //去除掉未解析的{}
        模版 = 模版.replace(/\{\{(.*?)\}\}/g, '');
        return 模版;
    },
    解析ja数据: function (模版, ja数据, name) {
        let tmpstr = '/\\{\\{' + name + '(.*?)\\}\\}(.*?)\\{\\{\\/' + name + '\\}\\}/';
        let 正则结果 = eval(tmpstr).exec(模版);
        if (!正则结果) return 模版;
        let 条件str = 正则结果[1];
        let 重复str = 正则结果[2];
        let str = '';
        if (条件str && 条件str.startsWith('|')) {
            let 条数 = 条件str.replace('|', '');
            条数 = parseInt(条数);
            if (条数 > 0 && ja数据.length % 条数 != 0) {
                let 补充数量 = 条数 - ja数据.length % 条数;
                console.log(条件str, '补充数量', 补充数量);
                for (let index = 0; index < 补充数量; index++) {
                    ja数据.push({});
                }
            }
        }
        ja数据.forEach((jo, index) => {
            jo['\\$index'] = index + 1;
            str += this.解析jo数据(重复str, jo);
        });
        return 模版.replace(正则结果[0], str);
    },

    选择打印机: function () {
        return new Promise((resolve, reject) => {
            if (!window.LODOP) reject('请先<a target="_blank" href="https://soft.ydcxt.com/CLodop_Setup_for_Win32NT.exe">安装web打印服务C-Lodop</a>，安装完毕后刷新网页!');
            window.LODOP.On_Return = function (TaskID, Value) {
                if (Value >= 0) {
                    resolve(Value);
                } else {
                    reject();
                }
            };
            window.LODOP.SELECT_PRINTER();
        });
    },
    打印: function (str) {
        return new Promise((resolve, reject) => {
            try {
                this.检查打印控件();
                window.LODOP.SET_PRINT_MODE("SEND_RAW_DATA_ENCODE", "GBK");
                window.LODOP.On_Return = function (TaskID, Value) {
                    if (Value) {
                        resolve(Value);
                    } else {
                        reject();
                    }
                };
                window.LODOP.SEND_PRINT_RAWDATA(str);
            } catch (error) {
                reject(error.message || error)
            }
        });
    },
    预览: function (str, 纸张类型 = 1, 宽度 = 2410, 高度 = 1400) {
        return new Promise((resolve, reject) => {
            try {
                this.检查打印控件();
                let LODOP = window.LODOP;
                window.LODOP.PRINT_INIT("打印任务名");
                //window.LODOP.PRINT_INITA(0, 0, 2410, 1400, "打印控件功能演示_Lodop功能_自定义纸张1");
                window.LODOP.SET_PRINT_PAGESIZE(纸张类型, 宽度, 高度);

                if (Array.isArray(str)) {
                    str.forEach(e => {
                        window.LODOP.NewPageA();
                        window.LODOP.ADD_PRINT_TABLE(0, 0, "100%", "100%", e)
                    });
                } else {
                    window.LODOP.ADD_PRINT_TABLE(0, 0, "100%", "100%", str)
                }

                // window.LODOP.ADD_PRINT_HTM("282mm", "48%", "200mm", 100, "<font color='#000'><span tdata='pageNO'>第##页</span>/<span tdata='pageCount'> 共##页</span></font>"); // 打印页码
                // window.LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
                // window.alert('--');

                // LODOP.ADD_PRINT_TEXT(0, 100, 165, 22, "第#页/共&页");
                // LODOP.SET_PRINT_STYLEA(0, "ItemType", 2);
                // LODOP.SET_PRINT_STYLEA(0, "Horient", 1);
                // LODOP.SET_PRINT_STYLEA(0, "Vorient", 1);

                window.LODOP.PREVIEW();
                window.LODOP.On_Return = function (TaskID, Value) {
                    if (parseInt(Value)) {
                        resolve(Value);
                    } else {
                        reject();
                    }
                };
            } catch (error) {
                reject(error.message || error)
            }
        });
    },
    检查打印控件: function (resolve, reject) {
        if (!window.LODOP) {
            try {
                let script3 = document.createElement('script')
                script3.type = 'text/javascript'
                script3.src = 'https://localhost:8443/CLodopFuncs.js'
                document.getElementById("app").appendChild(script3)
                //向网页中插入script
                let script = document.createElement('script')
                script.type = 'text/javascript'
                script.src = 'http://localhost:18000/CLodopFuncs.js'
                document.getElementById("app").appendChild(script)

                let script2 = document.createElement('script')
                script2.type = 'text/javascript'
                script2.src = 'http://localhost:8000/CLodopFuncs.js'
                document.getElementById("app").appendChild(script2)
            } catch (error) {
                console.log(error);
            }
        }

        if (!window.LODOP) {
            throw '请先<a target="_blank" href="https://soft.ydcxt.com/CLodop_Setup_for_Win32NT.exe">安装web打印服务C-Lodop</a>，安装完毕后刷新网页!';
        }
    }
}